module.exports = "<div class=\"button-group {{ 'button-group--' + type }} {{ full ? 'button-group--full' : ''}}\">\r\n    <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/button-group/button-group.component.html
// module id = 47
// module chunks = 0 1